/* @flow */
import React from 'react';
import ReactDOM, { unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer } from 'react-dom'; // eslint-disable-line camelcase
import ToastsContainer from 'components/ToastsContainer.jsx';

class ToastsContainerNode extends React.Component {
  componentDidMount() {
    this.build();
  }

  componentWillUnmount() {
    this.cleanup();
  }

  node: any;

  cleanup() {
    ReactDOM.unmountComponentAtNode(this.node);
  }

  build() {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);

    renderSubtreeIntoContainer(
      this,
      <ToastsContainer />,
      this.node,
    );
  }

  render() {
    return null;
  }
}

export default ToastsContainerNode;



// WEBPACK FOOTER //
// ./src/components/ToastsContainerNode.jsx